// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"fdd3e9f6","740":"67750a7f"}[chunkId] + ".css";
};